/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type SubmitGooseGameQuestionQuestLogMutationVariables = Types.Exact<{
  eventAttendeeId: Types.Scalars["Float"];
  questId: Types.Scalars["Float"];
  answer: Types.Scalars["String"];
}>;

export type SubmitGooseGameQuestionQuestLogMutation = {
  submitGooseGameQuestionQuestLog: Pick<
    Types.GooseGameQuestLog,
    | "id"
    | "event_attendee_id"
    | "quest_id"
    | "created_at"
    | "scanned_event_attendee_id"
    | "event_activity_id"
  >;
};

export const SubmitGooseGameQuestionQuestLogDocument = gql`
  mutation SubmitGooseGameQuestionQuestLog(
    $eventAttendeeId: Float!
    $questId: Float!
    $answer: String!
  ) {
    submitGooseGameQuestionQuestLog(
      event_attendee_id: $eventAttendeeId
      quest_id: $questId
      answer: $answer
    ) {
      id
      event_attendee_id
      quest_id
      created_at
      scanned_event_attendee_id
      event_activity_id
    }
  }
`;

/**
 * __useSubmitGooseGameQuestionQuestLogMutation__
 *
 * To run a mutation, you first call `useSubmitGooseGameQuestionQuestLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitGooseGameQuestionQuestLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitGooseGameQuestionQuestLogMutation, { data, loading, error }] = useSubmitGooseGameQuestionQuestLogMutation({
 *   variables: {
 *      eventAttendeeId: // value for 'eventAttendeeId'
 *      questId: // value for 'questId'
 *      answer: // value for 'answer'
 *   },
 * });
 */
export function useSubmitGooseGameQuestionQuestLogMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SubmitGooseGameQuestionQuestLogMutation,
    SubmitGooseGameQuestionQuestLogMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    SubmitGooseGameQuestionQuestLogMutation,
    SubmitGooseGameQuestionQuestLogMutationVariables
  >(SubmitGooseGameQuestionQuestLogDocument, baseOptions);
}
export type SubmitGooseGameQuestionQuestLogMutationHookResult = ReturnType<
  typeof useSubmitGooseGameQuestionQuestLogMutation
>;
export type SubmitGooseGameQuestionQuestLogMutationResult =
  ApolloReactCommon.MutationResult<SubmitGooseGameQuestionQuestLogMutation>;
export type SubmitGooseGameQuestionQuestLogMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SubmitGooseGameQuestionQuestLogMutation,
    SubmitGooseGameQuestionQuestLogMutationVariables
  >;
